import { CartResponse } from '../../models/Cart';
import graphqlApi from '../api/graphqlApi';
import useSWR from 'swr';
import { retrieveShopifyCart } from './queries/shopifyCart';

const useShopifyCartSWR = (cart_token) => {
    const fetchAllCartItem = (query): Promise<CartResponse> => {
        return graphqlApi
            .post(query, { id: cart_token })
            .then((res) => {
                return res.cart;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate, isValidating } = useSWR(
        retrieveShopifyCart(),
        fetchAllCartItem,
        {
            revalidateOnFocus: false,
        }
    );

    return {
        cart: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
        isValidating: isValidating,
    };
};

export default useShopifyCartSWR;
